module.exports = __webpack_public_path__ + "media/images/front/icons/arrow-down-a24f4ec51a57f8adb8fe9597d4681b0e.svg";